import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../../../components/Grid';
import Icon from '../../../components/Icon';
import messages from './messages';

class EventSignUpButton extends React.Component {
  static propTypes = {
    intl: PropTypes.object,
    hasCoppaFerpaBlock: PropTypes.bool,
    hasFerpaBlock: PropTypes.bool,
    registrationUrl: PropTypes.string,
    showTooltip: PropTypes.bool,
    toggleTooltipOn: PropTypes.func.isRequired,
    toggleTooltipOff: PropTypes.func.isRequired,
    handleRegistrationUrlClicked: PropTypes.func.isRequired,
  };

  renderCoppaBlockedSignUpButton = () => {
    const tooltipText = this.props.hasFerpaBlock
      ? messages.ferpaBlockText
      : messages.coppaBlockText;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <div
              className="event-row-sign-up-container"
              data-cy="event-row-signup"
              onMouseEnter={this.props.toggleTooltipOn}
              onMouseLeave={this.props.toggleTooltipOff}
            >
              {this.props.showTooltip && (
                <div className="event-row-sign-up-tooltip-container">
                  <div
                    className="event-row-sign-up-tooltip"
                    data-cy="event-row-sign-up-tooltip"
                  >
                    <div className="arrow" />
                    <div className="text">
                      <FormattedMessage {...tooltipText} />
                    </div>
                    <div className="hint">
                      <FormattedMessage {...messages.coppaFerpaBlockHint} />
                    </div>
                  </div>
                </div>
              )}
              <div className="event-row-sign-up coppa-block">
                <FormattedMessage {...messages.signup} /> <Icon name="external share" />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  renderCoppaUnblockedSignUpButton = () => {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <div
              className="event-row-sign-up"
              data-cy="event-row-signup"
              onClick={this.props.handleRegistrationUrlClicked}
            >
              <a
                href={this.props.registrationUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage {...messages.signup} /> <Icon name="external share" />
              </a>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  render() {
    if (this.props.hasCoppaFerpaBlock) return this.renderCoppaBlockedSignUpButton();
    return this.renderCoppaUnblockedSignUpButton();
  }
}

export default injectIntl(EventSignUpButton);
